import React from "react";  
import styles from "./Header.module.css";  
  
const Header = ({ onClose }) => {  
  return (  
    <div className={styles.header}>  
        <div className={styles.headerLogo}>  
          {/* <img src="https://via.placeholder.com/30" alt="Logo" />   */}
          <span className={styles.headerTitle}>Bata Bot</span>  
        </div>  
        <div className={styles.headerIcons}>  
          
          <span className={styles.headerIcon} onClick={onClose}>&times;</span> {/* Close Icon */}  
        </div>  
      </div>  
  );  
};  
  
export default Header;  